import React, { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";
import offline from "../../Assets/offline.jpeg"
import "./Offline.css";

const Offline = () => {

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);

    // Check when each box comes into view
    const inView1 = useInView(ref1, { once: true, threshold: 0.2 });
    const inView2 = useInView(ref2, { once: true, threshold: 0.2 });
    const inView3 = useInView(ref3, { once: true, threshold: 0.2 });
    const inView4 = useInView(ref4, { once: true, threshold: 0.2 });

    const boxVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (delay) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, delay }
        }),
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="offline-container">
                <div className="offline-topic">
                    <h1>Offline Marketing</h1>
                </div>
                <div className="def">
                    <span className="def-content">Online marketing is the process of promoting your business, products, or services using digital channels like search engines,
                        social media, email, and websites. It helps you reach a wider audience, attract potential customers, and drive sales through targeted strategies such as SEO,
                        paid ads, and content marketing.
                        With the right approach, online marketing boosts brand awareness, improves engagement, and delivers measurable results.
                    </span>
                </div>
                <div className="OM-benefits" style={{ marginLeft: "5%" }}>
                    <h2 className="OM-question">Benefits of Offline Marketing:-</h2>
                    <div className="fullDM-content">
                        <span className="DM-content" style={{ marginTop: "15px", flexDirection: "column" }}>Offline marketing remains a powerful way to connect with customers in the real world, building trust and
                            brand recognition through direct and personal interactions. Here are some key benefits of offline marketing:
                            <ul className="ul-points">
                                <li className="point">Stronger Personal Connections – Face-to-face interactions, events, and print materials create
                                    a lasting impression and build trust..</li>
                                <li className="point">Targeted Local Reach – Traditional marketing methods like billboards, flyers,
                                    and local ads effectively engage nearby customers.</li>
                                <li className="point">Brand Credibility – Printed materials, TV, and radio ads add legitimacy and
                                    a sense of reliability to your brand.</li>
                                <li className="point">Less Digital Competition – Offline marketing helps you stand out in a space
                                    where competitors aren’t fighting for online attention.</li>
                                <li className="point">Complements Online Marketing – Combining offline strategies with digital efforts creates
                                    a well-rounded marketing approach for better results.</li>
                            </ul>
                        </span>
                        <div className="digi-image">
                            <img style={{ width: "350px", height: "480px" }} className="apps-img" src={offline} alt="apps" />
                        </div>
                    </div>
                </div>
                <div className="DM-benefits">
                    <h1 className="DM-nextquestion">Services we provide to upscale your business !</h1>
                    <div className="boxes">
                        <motion.div
                            ref={ref1}
                            initial="hidden"
                            animate={inView1 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0}
                            className="point-box"
                        >
                            <h2 className="point-topic">Print & Event Marketing</h2>
                            <span className="point-content">Offline marketing services for print and event marketing include designing and producing high-quality materials such as brochures,
                                flyers, business cards, and banners to enhance brand visibility. Additionally, they involve event planning, sponsorships, trade shows,
                                and promotional campaigns to engage potential customers and create lasting brand impressions.</span>
                        </motion.div>

                        <motion.div
                            ref={ref2}
                            initial="hidden"
                            animate={inView2 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.3}
                            className="point-box"
                        >
                            <h2 className="point-topic">Outdoor Advertisements</h2>
                            <span className="point-content">Outdoor advertising services include designing and placing eye-catching ads on billboards, transit media, posters, and digital screens in high-traffic locations.
                                These ads help businesses increase brand visibility, attract local customers,
                                and create a strong offline presence through strategic placement and compelling visuals.</span>
                        </motion.div>

                        <motion.div
                            ref={ref3}
                            initial="hidden"
                            animate={inView3 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.6}
                            className="point-box"
                        >
                            <h2 className="point-topic">Sales trading</h2>
                            <span className="point-content">Sales trading services involve buying and selling financial instruments like stocks, bonds, and derivatives on behalf of clients or firms. They provide market analysis,
                                execute trades quickly, and offer strategic advice to maximize profits while managing risks. These services are essential for
                                investors looking for efficient trade execution and expert market insights.</span>
                        </motion.div>

                        <motion.div
                            ref={ref4}
                            initial="hidden"
                            animate={inView4 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.9}
                            className="point-box"
                        >
                            <h2 className="point-topic">Networking and relationship building</h2>
                            <span className="point-content">Networking and relationship-building services focus on connecting businesses and professionals
                                to foster growth, partnerships, and opportunities. This includes organizing industry events, business meetups,
                                and strategic collaborations to build trust, expand contacts, and enhance brand credibility.
                                Strong relationships lead to increased referrals, business deals, and long-term success.</span>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Offline;